import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = ["Insights", "About", "Speaking", "Contact"];

  return (
    <motion.header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#121418]/80 border-b border-white/10" : "bg-transparent"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="/" data-testid="header-logo" className="font-['Cormorant_Garamond'] text-2xl font-light tracking-tight text-[#F9F6F0] hover:text-[#C4963B] transition-colors duration-300">
          Joe Atkinson
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              data-testid={`nav-${item.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.15em] text-[#E8E6E1]/60 hover:text-[#C4963B] transition-colors duration-300 font-medium"
            >
              {item}
            </a>
          ))}
          <motion.a
            href="#contact"
            data-testid="header-lets-talk-btn"
            className={`text-xs uppercase tracking-[0.15em] px-6 py-2.5 border transition-all duration-300 font-medium ${
              scrolled
                ? "border-[#C4963B] text-[#C4963B] hover:bg-[#C4963B] hover:text-[#121418]"
                : "border-[#F9F6F0]/20 text-[#F9F6F0] hover:border-[#C4963B] hover:text-[#C4963B]"
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Let's Talk
          </motion.a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#F9F6F0] relative w-6 h-5"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span className={`absolute left-0 w-6 h-[1.5px] bg-current transition-all duration-300 ${mobileOpen ? "top-2 rotate-45" : "top-0"}`} />
          <span className={`absolute left-0 top-2 w-6 h-[1.5px] bg-current transition-opacity duration-300 ${mobileOpen ? "opacity-0" : ""}`} />
          <span className={`absolute left-0 w-6 h-[1.5px] bg-current transition-all duration-300 ${mobileOpen ? "top-2 -rotate-45" : "top-4"}`} />
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden backdrop-blur-xl bg-[#121418]/95 border-t border-white/10 overflow-hidden"
          >
            <div className="px-6 py-8 space-y-6">
              {links.map((item) => (
                <a key={item} href={`#${item.toLowerCase()}`} className="block text-lg text-[#E8E6E1]/70 hover:text-[#C4963B] transition-colors" onClick={() => setMobileOpen(false)}>
                  {item}
                </a>
              ))}
              <a href="#contact" className="block w-full text-center py-3 border border-[#C4963B] text-[#C4963B] text-sm uppercase tracking-[0.15em]" onClick={() => setMobileOpen(false)}>
                Let's Talk
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
